module.exports = __webpack_public_path__ + "static/media/amazon.83782423.png";